// ============================================
// Path: /frontend/src/lib/categories.js
// Purpose: Vehicle types and property categories
// ============================================

export const vehicleTypes = [
  "Salvage",
  "Grounded",
  "Cars",
  "Vans and Minibusses",
  "Busses",
  "Lorries and Trailers",
  "PickUps",
  "Motor Bikes",
  "Heavy Machinery",
];

export const propertyTypes = [
  {
    name: "Houses for Sale",
    subTypes: ["Apartment", "Maisonette", "Bungalow", "Beach Property"]
  },
  { name: "Off Plan" },
  { 
    name: "Houses to let",
    subTypes: ["Apartment", "Maisonette", "Bungalow", "Studio Unit", "Bedsitter", "One Bedroom", "Two Bedroom", "Three bedroom"]
  },
  { 
    name: "Land to Let",
    subTypes: ["Agricultural land", "Rural Area plot", "Urban Center Plot", "Residential land"]
  },
  { 
    name: "Land for Sale",
    subTypes: ["Agricultural land", "Rural Area plot", "Urban Center Plot", "Residential land"]
  },
  { 
    name: "Commercial Property for sale",
    subTypes: ["Office Space", "Supermarket Space", "Storage Space", "Shopping Mall Space", "Commercial Buildings", "Schools", "Ongoing Business"]
  },
  { 
    name: "Commercial property to let",
    subTypes: ["Office Space", "Supermarket Space", "Storage Space", "Shopping Mall Space"]
  },
  { name: "Bed and Breakfast / Air BB" },
  { name: "Godowns and Warehouses for Sale" },
  { name: "Godowns and Warehouses to let" },

];